import { createAction, props } from '@ngrx/store';
import { SidebarSettingsModel } from '../../../models/sidebar-settings.model';

export const loadSidebarSettings = createAction('[SideBar Settings] Load');

export const loadSidebarSettingsSuccess = createAction(
  '[SideBar Settings] Load Successful',
  props<{ response: SidebarSettingsModel }>()
);

export const loadSidebarSettingsFailed = createAction(
  '[SideBar Settings] Load Failed',
  props<{ error: any }>()
);

export const toggleSidebarShown = createAction('[SideBar Settings] Toggle');
